"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = onWindowResize;
const WindowEvent_1 = require("../../Framework/Decorators/WindowEvent");
function onWindowResize() {
    return (0, WindowEvent_1.default)('resize');
}
//# sourceMappingURL=OnWindowResize.js.map